import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Vortex } from 'react-loader-spinner'

function Iponews() {
    const { BaseURL } = useContext(URLstateContext);
    const [dataIpo, setDataIpo] = useState([]);
   const [companyInfo, setCompanyInfo] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    let companyInformation;
    let  getDataIpo;
    let navigate = useNavigate();

    useEffect(() => {
        setloadingshow(true);
        const getUrlIpo = BaseURL + "News";
        fetch(`${getUrlIpo}/28/117/-/8`)
            .then((response) => response.json())
            .then((dataI) => {
                getDataIpo = dataI.data;
                setDataIpo(getDataIpo);
                companyInformation = dataI.data;
                setCompanyInfo(companyInformation);
                setloadingshow(false);
            })
            .catch((error) => {
            });
    }, []);


    const routeChange = (event) => {
        const fetchId = event.currentTarget.getAttribute('data-id');
        const fetchHead = event.currentTarget.getAttribute('data-head');
        window.open("/Detail-News/" + fetchId + "/" + fetchHead.replace(/ /g, '-').replace('&', 'and').replace('/', 'slash').replace(/\./g,'').replace('?', 'questionMark').replace('=', 'isEqualsTo').replace(':', 'colon').replace('%', 'Percent'), '_blank');
    };


    const moreContent = () => {
        navigate("/IPO/IPO-News")
    }

    return (
        <>
            <div className='market-inner-common ipo-head'>
                <div className='market-header'>
                    <h4>IPO News</h4>
                    <span className="moreContent" onClick={moreContent} tabIndex={0} >See More</span>
                </div>
                {(dataIpo === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                <Container className="add-border table-box">
                    {(dataIpo != null) && dataIpo.map(
                        ({ Heading, Date, Time, Sno }) => (
                            <>
                                <div className="IPOnews-wq">
                                    <div className="IPOnews-wq-inner">
                                        <div className="IPOnews-wq-betaNews">
                                            <div className="IPOnews-gutter">
                                                        <h6 className="newheadIpo more-info" onClick={routeChange} data-head={Heading} data-id={Sno} tabIndex={0} >{Heading} </h6>
                                                        <p> {(Date.split('T')[0])}  ({Time})</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}
                    {loadingshow ? <div className="textcentervertex">
                        <Vortex
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="vortex-loading"
                            wrapperStyle={{}}
                            wrapperClass="vortex-wrapper"
                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                        />
                        <div className="model_popup">Please Wait...</div>
                    </div> : ""
                    }
                </Container>
            </div>
        </>
    );
}

export default Iponews;

